import React, { useCallback } from 'react';

import { OTP_NOTIFICATION_FIELDS } from '../../common/fields';
import { SUBCATEGORIES } from '../../common/categories';
import * as actions from '../../containers/DesktopApplication/desktopApplicationActions';

import ImageUpload from '../Controls/ImageUpload/ImageUpload';
import SelectField from '../Controls/SelectField/SelectField';
import SwitchField from '../Controls/SwitchField/SwitchField';
import TextInput from '../Controls/TextInput/TextInput';
import Button from '../Controls/Button/Button';

const { OTP_NOTIFICATION } = SUBCATEGORIES;

const OTPNotification = ({ fields, dispatch, defaultData }) => {
    const notificationIcon = fields[OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_ICON.ID];
    const notificationBackground1 = fields[OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_BACKGROUND1.ID];
    const notificationBackground2 = fields[OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_BACKGROUND2.ID];
    const displayIconEnabled = fields[OTP_NOTIFICATION_FIELDS.OTP_DISPLAY_ICON_ENABLED.ID];
    const notificationHeight = fields[OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_HEIGHT.ID];
    const notificationWidth = fields[OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_WIDTH.ID];
    const windowPosition = fields[OTP_NOTIFICATION_FIELDS.OTP_WINDOW_POSITION.ID];
    const notificationText = fields[OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_TEXT.ID];
    const showOtpOnAutoPairedDevices = fields[OTP_NOTIFICATION_FIELDS.OTP_ON_AUTO_PAIRED_DEVICES.ID];

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_OTP_NOTIFICATION,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    const backToDefault = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.BACK_TO_DEFAULT,
                payload: { tabId: OTP_NOTIFICATION.ID, defaultData: defaultData }
            });
        },
        [dispatch, defaultData]
    );

    return (
        <>
            {notificationIcon && <ImageUpload field={notificationIcon} allowRemove changed={dispatchUpdate} />}
            {notificationBackground1 && (
                <ImageUpload field={notificationBackground1} allowRemove changed={dispatchUpdate} />
            )}
            {notificationBackground2 && (
                <ImageUpload field={notificationBackground2} allowRemove changed={dispatchUpdate} />
            )}
            {displayIconEnabled && <SwitchField field={displayIconEnabled} changed={dispatchUpdate} />}
            {notificationHeight && <TextInput field={notificationHeight} changed={dispatchUpdate} />}
            {notificationWidth && <TextInput field={notificationWidth} changed={dispatchUpdate} />}
            {windowPosition && (
                <SelectField
                    field={windowPosition}
                    changed={dispatchUpdate}
                    options={[
                        { value: true, label: 'Center' },
                        { value: false, label: 'Next to tray icon' }
                    ]}
                />
            )}
            {notificationText && (
                <TextInput field={notificationText} type="textarea" rows="3" changed={dispatchUpdate} />
            )}
            {showOtpOnAutoPairedDevices && <SwitchField field={showOtpOnAutoPairedDevices} changed={dispatchUpdate} />}
            <Button onClick={backToDefault}>Reset defaults</Button>
        </>
    );
};

export default React.memo(OTPNotification);
